import { Component, Input } from '@angular/core';
import { AsyncPipe, NgIf } from '@angular/common';
import { Observable } from 'rxjs';
import { PanelModule } from 'primeng/panel';
import { DividerModule } from 'primeng/divider';
import { DashboardOverviewPanelDataComponent } from '../dashboard-overview-panel-data/dashboard-overview-panel-data.component';
import { DashboardGraphComponent } from '../dashboard-graph/dashboard-graph.component';
import { OverviewPanelData } from '@app/areas/dashboard/utils/overview.util';
import { DashboardChartData } from '@app/areas/dashboard/models/chart.model';

/**
 * Overview panel: a colored header bar, the location-spend chart, and a 2x2 grid
 * of stat tiles.
 */
@Component({
  selector: 'app-dashboard-overview-panel',
  templateUrl: './dashboard-overview-panel.component.html',
  styleUrls: ['./dashboard-overview-panel.component.scss'],
  standalone: true,
  imports: [NgIf, AsyncPipe, PanelModule, DividerModule, DashboardOverviewPanelDataComponent, DashboardGraphComponent],
})
export class DashboardOverviewPanelComponent {
  @Input() header = 'SALES OVERVIEW';
  @Input() tiles: OverviewPanelData[] = [];
  @Input() graphData$: Observable<DashboardChartData> | null = null;
  @Input() showChartData = true;
}
